import styles from './index.less';
import $ from 'jquery';
import { jsToCss } from '../../utils/utils';

const defaultPrams = {
  content: '',
  wrapperStyle: {
    height: '40px',
    backgroundColor: 'rgba(0,0,0,.6)',
  },
  textStyle: {
    color: 'rgba(255,255,255,.5)',
    fontFamily: '微软雅黑',
    fontSize: '14px',
    fontStyle: 'italic',
    fontWeight: 'bold',
    letterSpacing: '10px',
    lineHeight: '40px',
    textAlign: 'center',
    textDecoration: 'line-through',
    textIndent: '20px',
  },
  speed: 200, //每秒滚动的距离  px
  duration: 5, //播放间隔  s
};
export default class TextScroll {
  constructor(props) {
    const { wrapper, ...params } = props;
    this.wrapper = wrapper;
    this.params = {
      ...defaultPrams,
      ...params,
    };
    this._init();
  }
  _init() {
    this._initContent();
    this._animate();
  }
  _initContent() {
    const params = this.params;
    this.$content = $(
      `<div style="${jsToCss(params.wrapperStyle)}" class="${styles['scroll-wrapper']}"></div>`,
    );
    this.$swiper = $(`<div style="${jsToCss(params.textStyle)}" class="${styles['scroll-text']}">
      ${params.content}
    </div>`);
    this.$content.append(this.$swiper);
    $(this.wrapper).append(this.$content);

    this.wrapperWidth = this.$content.width();
    this.swiperWidth = this.$swiper.width();
    this.$swiper.css('marginLeft', `${this.wrapperWidth}px`);
  }

  _animate() {
    const { speed, duration } = this.params;
    const left = this.$swiper.css('marginLeft').replace('px', '');

    if (Math.abs(left) > this.swiperWidth && left < 0) {
      this.$swiper.css('marginLeft', `${this.wrapperWidth}px`);
      setTimeout(() => {
        this._animate();
      }, duration * 1000);
      return;
    }

    const next = left - speed;
    this.$swiper.animate(
      {
        marginLeft: `${next}px`,
      },
      1000,
      'linear',
      () => {
        this._animate();
      },
    );
  }
  remove() {
    this.params = defaultPrams;
    this.$content.remove();
  }
}
